module.exports = {"120101001":"劝业场街道","120101002":"小白楼街道","120101003":"五大道街道","120101004":"新兴街道","120101005":"南营门街道","120101006":"南市街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120101.json
// module id = 125
// module chunks = 0